module.exports = __webpack_public_path__ + "static/heroImage3-259bfefe65eabdb7747cde43177d95e1.jpg";